import Vue from 'vue'
import Vuex from 'vuex'
import main from "@/store/main";
import publicInfo from './modules/publicInfo'
import ssr from "@/store/modules/ssr";
import aaa from "@/store/modules/AAA";
import asl from '@/store/modules/asl'



Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		main,publicInfo,ssr,aaa,asl
	},
})
